import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import type { ContractDetailContractVersionRequestFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { FLOWS } from 'modules/contracts/components/FlowSelectorModal/constants'

interface Props {
  onCloseModal: () => void
  contractVersionRequest: ContractDetailContractVersionRequestFragment
  canPromote: boolean
}

const PendingApprovalModal = ({ onCloseModal, contractVersionRequest, canPromote }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const {
    access: { id: accessId },
  } = useCurrentSession()

  const onSubmit = () => {
    if (contractVersionRequest.id && contractVersionRequest.employee?.id) {
      track(trackingEvents.employee.contracts.goToContractRequest, {
        source: 'modal',
        approval_status: contractVersionRequest.status,
        request_type: FLOWS.promotion,
        request_date: contractVersionRequest.approvalRequestCreatedAt,
        request_reason: contractVersionRequest.requestDetails,
      })
      navigate(
        navigation.employees.id.contractVersions.approval_request.fullPath({
          contractVersionId: contractVersionRequest.id,
          id: contractVersionRequest.employee.id,
        })
      )
    }
  }

  const canSeeApprovalRequest = () => {
    const status = contractVersionRequest.status

    if (!contractVersionRequest.id || !canPromote || !status) return false

    const approversIds = contractVersionRequest.approversIds || []
    const currentAccessIsApprover = approversIds.includes(accessId)

    return canPromote || currentAccessIsApprover
  }

  return (
    <Modal
      title={i18n.t('contract_versions.modals.pending_request.title', {
        requesterName: contractVersionRequest.approvalAuthor?.fullName ?? '',
      })}
      illustration="alert"
      onSubmit={onSubmit}
      onClose={onCloseModal}
      description={i18n.t('contract_versions.modals.pending_request.description')}
      footer={
        <>
          <Button disabled={false} onClick={onCloseModal} type="secondary">
            {canSeeApprovalRequest()
              ? i18n.t('common.cancel')
              : i18n.t('contract_versions.modals.pending_request.back_button')}
          </Button>
          {canSeeApprovalRequest() && (
            <Button submit>
              {i18n.t('contract_versions.modals.pending_request.review_request')}
            </Button>
          )}
        </>
      }
    ></Modal>
  )
}

export default PendingApprovalModal
